export class TreatmentsList extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.opened = false

    this.hiddenCardEls = this.els?.card?.elements || []
    this.loadButtonEl = this.els?.load?.element
  }

  setupListeners () {
    super.setupListeners()

    this.loadButtonEl = this.els?.load?.element

    this.handleButtonClick = this.handleButtonClick.bind(this)

    if (this.loadButtonEl) {
      this.listeners.add(this.loadButtonEl, 'click', this.handleButtonClick)
    }
  }

  handleButtonClick () {
    this.opened = !this.opened

    this.hiddenCardEls.forEach(el => {
      el.setAttribute('aria-hidden', !this.opened)
    })

    this.loadButtonEl.innerText = this.opened
      ? this.loadButtonEl.dataset.seeLessText
      : this.loadButtonEl.dataset.seeMoreText
  }
}

if (!customElements.get('treatments-list')) {
  customElements.define('treatments-list', TreatmentsList)
}
